import EventEmitter from 'eventemitter3';

let Observer = new EventEmitter();

let GLOBAL_EVENT = {
    // Eventos de comunicación con el CANVAS
    IMAGE_CHARGED: "IMAGE_CHARGED",
    IMAGE_CHARGED_COMPLETE: "IMAGE_CHARGED_COMPLETE",
    ZOOM_CHANGED: "ZOOM_CHANGED",
    EXTRUSION_CHANGED: "EXTRUSION_CHANGED",
    PANEL_RESIZE_END: "PANEL_RESIZE_END",
    IMAGE_SELECTED: "IMAGE_SELECTED", // Esto recivirá el ID de la imagen seleccionada
    IMAGE_DES_SELECTED: "IMAGE_DES_SELECTED",

    // Export
    OPEN_EXPORT_OPTIONS_PC: "OPEN_EXPORT_OPTIONS_PC",
    // El export solicita la imágen al canvas y cuando está lista ejecuta image_canvas_expoted
    REQUEST_IMAGE_CANVAS: "REQUEST_IMAGE_CANVAS",
    IMAGE_CANVAS_EXPORTED: "IMAGE_CANVAS_EXPORTED",

    IMPORT_ATLAS: {
        // Abrir modal de import atlas
        OPEN_ATLAS_IMPORT: "OPEN_ATLAS_IMPORT",
        OPEN_ATLAS_IMPORT_SEND_IMAGE: "OPEN_ATLAS_IMPORT_SEND_IMAGE",
        CLOSE_ATLAS_IMPORT: "CLOSE_ATLAS_IMPORT",
        // Estado de import atlas
        CHANGE_IMPORT_ATLAS_STATE: "CHANGE_IMPORT_ATLAS_STATE",
        // Botón de importación
        IMPORT_ATLAS_GRID_BUTTON: "IMPORT_ATLAS_GRID_BUTTON",
        // Lo usamos para enviar el atlas JSON al render
        IMPORT_ATLAS_JSON: "IMPORT_ATLAS_JSON"
    },
    IMPORT_GIF: 'IMPORT_GIF',
    // Sistema de notificaciones
    NOTIFICATION_SYSTEM: {
        SUCCESS: 'SUCCESS',
        WARNING: 'WARNING',
        ERROR: 'ERROR',
        CLEAR: 'CLEAR'
    },
    // Sistema de loading
    SPINNER: {
        OPEN: 'OPEN_SPINNER',
        CLOSE: 'CLOSE_SPINNER'
    },
    RESET_ATLAS: 'RESET_ATLAS'
};

// Tipados
export interface ImageCanvasData {
    name: string,
    src: string,
    src_original: string,
    type: string,
    scale: number
}

export interface GifImports {
    name: string,
    width: number,
    height: number,
    srcs: Array<string>
}

export {
    Observer,
    GLOBAL_EVENT
};